import { AxiosResponse } from "axios";
import { IResolveResponse } from "../ResolveApi/resolve-api.types";
import { IUserAccount } from "../../App/types/common";

export function parseUserAccountResponse<Type>(response: AxiosResponse<IResolveResponse<Type>, any>): Type {
  return response.data[0].value;
}

export const getCurrentAliases = (userAccountState: IUserAccount) =>
  userAccountState.aliases.elems.find(a => a.state.namespace === `org.${userAccountState.owner}`);
